import { z } from 'zod';
import { v } from '../utils/validators';
import { type MakeValuesOptionalString } from './environment.types';

// UNOPTIMIZED: Introduce the Config paradigm for accessing real-time settings.
export const appEnvironmentSchema = z.object({
  DEBUG: z.string().optional(),
  VITE_APP_PRAYER_STREAM_BFF_URL: v.strictUrl(),
  VITE_APP_PRAYER_STREAM_MEMBER_CENTER_URL: v.strictUrl(),
  VITE_APP_PRAYER_STREAM_NEW_RELIC_APP_ID: v.newRelicAppId(),
  VITE_APP_PRAYER_STREAM_OKTA_CLIENT_ID: v.oktaClientId(),
  VITE_APP_PRAYER_STREAM_OKTA_ISSUER: v.oktaIssuer(),
  VITE_APP_PRAYER_STREAM_PAIRING_AND_SHARING_ENABLED: v.stringbool(),
  VITE_APP_PRAYER_STREAM_STREAM_API_KEY: z.string(),
  VITE_APP_PRAYER_STREAM_TACO: v.taco(),
});

export type AppEnvironment = z.infer<typeof appEnvironmentSchema>;

export type AppEnvironmentRaw = MakeValuesOptionalString<AppEnvironment>;
